import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 26, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.85, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Label({ children, className = "" }) {
  return (
    <p className={`mono-label text-teal flex items-center gap-2 ${className}`}>
      <span className="inline-block w-1.5 h-1.5 bg-teal rounded-full" />
      {children}
    </p>
  );
}

export function SectionHead({ label, title, lede, className = "" }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      <Reveal>
        <Label>{label}</Label>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-display font-semibold text-4xl sm:text-5xl leading-[0.98] tracking-tight mt-5">
          {title}
        </h2>
      </Reveal>
      {lede && (
        <Reveal delay={0.16}>
          <p className="text-mute text-base sm:text-lg leading-relaxed mt-5">{lede}</p>
        </Reveal>
      )}
    </div>
  );
}
